import React from 'react';
import PageHeader from './PageHeader/PageHeader';
import { useGetUserData } from '../../api';
import UserSessionContext from './UserSessionContext';

interface Props {
    children: React.ReactNode;
    icon: React.FC<React.SVGProps<SVGSVGElement>>;
    title: string;
}

const PageWrapper = ({ icon, title, children }: Props) => {
    const { userSession } = useGetUserData();

    return (
        <div className="h-screen w-full bg-white">
            <UserSessionContext.Provider value={{ userData: userSession }}>
                <div className="ml-[60px] flex h-full w-[calc(100%-60px)]">
                    <div className="h-full w-full flex flex-col flex-1">
                        <PageHeader icon={icon} title={title} />
                        <div className="flex h-full w-full">{children}</div>
                    </div>
                </div>
            </UserSessionContext.Provider>
        </div>
    );
};

export default PageWrapper;
